module["exports"] = [
  "Deutschland"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de/address/default_country.js
// module id = 925
// module chunks = 0